import gql from 'graphql-tag';

export const GET_MESSAGE_THREAD_MESSAGES_QUERY = gql`
  fragment MessagesMessageThreadMessage on MessageThreadMessage {
    content
    id
    updatedAt
    creatorId
    status
  }

  fragment MessagesMessageThreadMessagesSuccess on MessageThreadMessages {
    nodes {
      ...MessagesMessageThreadMessage
    }
  }
  fragment MessagesMessageThreadMessagesError on GenericError {
    kind
    message
  }

  query MessagesMessageThreadMessages($threadId: ID!) {
    messageThreadMessages(threadId: $threadId) {
      ...MessagesMessageThreadMessagesSuccess
      ...MessagesMessageThreadMessagesError
    }
  }
`;
